module.exports = __webpack_public_path__ + "static/img/banner-oportunidades-home-500x750.9d8f640.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-oportunidades-home-500x750.jpg
// module id = RO9e
// module chunks = 47